var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Button, GBTypography } from '@leapfinance/geebee-component-library';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Typography } from '@mui/material';
import { ReferralInfoIcon } from '../../icons';
var GICReferralCard = function (_a) {
    var referralCodeText = _a.referralCodeText, referralInfoText = _a.referralInfoText, className = _a.className, referralCopyButtonProps = _a.referralCopyButtonProps;
    var _b = __read(useState(false), 2), copied = _b[0], setCopied = _b[1];
    var handleClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var id;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setCopied(true);
                    if (!navigator) return [3 /*break*/, 2];
                    return [4 /*yield*/, navigator.clipboard.writeText(referralCodeText)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2:
                    id = setTimeout(function () {
                        setCopied(false);
                        clearTimeout(id);
                    }, 1500);
                    (_a = referralCopyButtonProps === null || referralCopyButtonProps === void 0 ? void 0 : referralCopyButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(referralCopyButtonProps, event);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "lfc-p-3 lfc-bg-secondaryVariant-100 lfc-rounded ".concat(className !== null && className !== void 0 ? className : '') },
        React.createElement("div", { className: "lfc-py-2 lfc-flex lfc-items-center lfc-gap-x-3 lfc-mb-4" },
            React.createElement(ReferralInfoIcon, null),
            React.createElement(GBTypography, { variant: "body4", className: "lfc-text-gray-900" }, referralInfoText !== null && referralInfoText !== void 0 ? referralInfoText : 'You can still earn the commission if you use this referral code while creating the GIC account.')),
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-1" },
            React.createElement(GBTypography, { variant: "sh2Semibold", className: "lfc-text-gray-600 " }, "Referral Code"),
            React.createElement("div", { className: "lfc-flex lfc-gap-x-2" },
                React.createElement("div", { className: "lfc-border lfc-border-gray-400 lfc-bg-gray-100 lfc-rounded lfc-py-2 lfc-px-3" },
                    React.createElement(Typography, { variant: "body2", className: "lfc-text-gray-600" }, referralCodeText)),
                React.createElement(Button, __assign({ variant: 'secondary', className: copied ? 'lfc-bg-gbTokens-success-600 lfc-text-white ' : '', onClick: handleClick, startIcon: copied ? React.createElement(ContentCopyIcon, { className: "lfc-text-[14px]" }) : undefined }, referralCopyButtonProps), copied ? 'Copied' : 'Copy')))));
};
export default GICReferralCard;
//# sourceMappingURL=GICReferralCard.js.map